module.exports = __webpack_public_path__ + "media/images/massage-e01bf293.jpg";